import { useTranslation } from 'react-i18next';

export default function Donate() {
  const { t } = useTranslation();

  return (
    <section id="donate" className="px-4 md:px-6 py-14 md:py-20 bg-secondary-900 text-background-50">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        <div>
          <span className="inline-block px-3 py-1 rounded-full bg-accent-500/20 text-accent-300 text-xs font-semibold uppercase tracking-wide">
            {t('donate.tag')}
          </span>
          <h2 className="mt-4 font-heading font-bold text-2xl md:text-4xl leading-tight">
            {t('donate.title')}
          </h2>
          <p className="mt-5 text-sm md:text-base text-secondary-100/80 leading-relaxed">
            {t('donate.subtitle')}
          </p>
          <a
            href="#contact"
            className="mt-7 inline-flex items-center gap-2 px-6 py-3 rounded-md bg-accent-500 text-background-50 font-semibold text-sm whitespace-nowrap hover:bg-accent-600 transition-colors cursor-pointer"
          >
            <i className="ri-team-line"></i>
            {t('donate.cta')}
          </a>
        </div>

        <div className="rounded-lg bg-background-50 text-foreground-900 p-6 md:p-8">
          <div className="flex items-center gap-2.5 mb-5">
            <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 text-lg">
              <i className="ri-bank-line"></i>
            </span>
            <h3 className="font-heading font-bold text-lg md:text-xl">
              {t('donate.bank')}
            </h3>
          </div>

          <dl className="space-y-4">
            <div className="flex flex-col gap-1">
              <dt className="text-xs text-foreground-500 uppercase tracking-wide">
                {t('donate.accountName')}
              </dt>
              <dd className="text-sm md:text-base font-semibold text-foreground-900">
                {t('donate.accountNameValue')}
              </dd>
            </div>
            <div className="flex flex-col gap-1">
              <dt className="text-xs text-foreground-500 uppercase tracking-wide">
                {t('donate.accountNo')}
              </dt>
              <dd className="text-lg md:text-xl font-heading font-bold text-primary-700 tracking-wider">
                {t('donate.accountNoValue')}
              </dd>
            </div>
            <div className="flex flex-col gap-1">
              <dt className="text-xs text-foreground-500 uppercase tracking-wide">
                {t('donate.bankName')}
              </dt>
              <dd className="text-sm md:text-base font-semibold text-foreground-900">
                {t('donate.bankNameValue')}
              </dd>
            </div>
          </dl>

          <p className="mt-6 text-xs text-foreground-500 leading-relaxed border-t border-background-200 pt-4">
            {t('donate.note')}
          </p>
        </div>
      </div>
    </section>
  );
}